import { Location } from 'history'
import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { Route } from 'react-router'
import { Router, Switch } from 'react-router-dom'
import { Dispatch } from 'redux'

import { driveThemes, Theme } from '../data/models/funnelOrder/theme'
import { setCountry, SiteCountry } from '../data/models/locale'
import { AppState } from '../data/state'
import ErrorBoundary from '../elements/ErrorBoundary'
import { SRPRS_ENV } from '../env'
import Reload from '../pages/Reload'
import { urls } from '../urls'
import { wait } from '../utils/promise'
import { getRedirects } from './components/Redirects'
import RedirectToCountryRoute from './components/RedirectToCountryRoute'
import { getCountryRoutes } from './country_routes'
import { getCountryFromUrl } from './functions'
import history from './history'

/** Outputs routes and keeps state.country up-to-date */
interface RoutesProps {
  requireAdminAuth: boolean
  country: SiteCountry
  theme: Theme

  setCountry(country: SiteCountry, userChange: boolean): void

  setTheme(theme: Theme): void
}

interface RoutesState {
  shouldUpdateApp: boolean
}

class Routes extends React.Component<RoutesProps, RoutesState> {
  public state: RoutesState = {
    shouldUpdateApp: false,
  }

  public matchUrlCountry = (location: Location) => {
    const newCC = getCountryFromUrl(location.pathname)
    if (newCC !== this.props.country) {
      // If URL country doesn't match country in state
      this.props.setCountry(newCC as SiteCountry, true) // Change country in state
    }
  }

  public setTheme = (location: Location) => {
    let urlMatchHome = false
    let foundUrl = false
    if ('/' + this.props.country === location.pathname) {
      urlMatchHome = true
    }
    for (const link of Object.entries(urls)) {
      for (const url of Object.entries(link['1'].urls)) {
        if (
          '/' + url['0'] + url['1'] === location.pathname ||
          (url['0'] === 'default' &&
            url['1'] === location.pathname.substring(3))
        ) {
          foundUrl = true
          if (
            link['1'].theme === undefined &&
            link['1'].funnel === undefined &&
            this.props.theme !== Theme.fly &&
            this.props.theme !== Theme.drive &&
            !link['1'].stopReset
          ) {
            if (
              driveThemes
                .filter(t => t !== Theme.train)
                .includes(this.props.theme)
            ) {
              this.props.setTheme(Theme.drive)
            } else {
              this.props.setTheme(Theme.fly)
            }
          } else if (
            link['1'].theme !== undefined &&
            link['1'].theme !== this.props.theme
          ) {
            this.props.setTheme(link['1'].theme as Theme)
          }
        }
      }
    }
  }

  public componentDidMount() {
    history.listen(this.matchUrlCountry)
    history.listen(this.setTheme)
    this.matchUrlCountry(history.location)
    this.setTheme(history.location)

    // TODO: Remove this editable hack
    if (SRPRS_ENV === 'editable') {
      fixEditableLabelsHack()
      history.listen(fixEditableLabelsHack)
    }
  }

  public render() {
    /* Build available country regexp */
    return (
      <Router history={history}>
        <ErrorBoundary>
          {this.state.shouldUpdateApp ? (
            <Reload />
          ) : (
            <Switch>
              {getCountryRoutes(this.props.requireAdminAuth)}

              {getRedirects(this.props.country)}

              <Route
                key="/:path*"
                path="/:path*"
                component={RedirectToCountryRoute}
              />
            </Switch>
          )}
        </ErrorBoundary>
      </Router>
    )
  }
}

const fixEditableLabelsHack = async () => {
  await wait(1000)
  const inLabels = Array.from(
    document.querySelectorAll('form label .editable-content'),
  )
  const inButtons = Array.from(
    document.querySelectorAll('button .editable-content-edit-btn'),
  )

  const moveUpInDomTree = (n: Node) => {
    const node: any = n.parentNode
    node.parentNode.appendChild(n)
    return n as Node
  }
  ;[...inLabels, ...inButtons].forEach(moveUpInDomTree)
}

const mapStateToProps = (state: AppState) => ({
  requireAdminAuth: SRPRS_ENV === 'editable' && !state.admin.token,
  country: state.locale.country,
  theme: state.funnelOrder.theme,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCountry: (country: SiteCountry, userChange: boolean) => {
    dispatch(setCountry(country, userChange))
  },
  setTheme: (theme: Theme) => {
    dispatch(actions.change('funnelOrder.theme', theme))
    dispatch(actions.change('funnelOrder.airports', []))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
